
import Icon from '@ant-design/icons';
import * as React from 'react';

const PendingIconSvg = (props) => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM6.45312 3.1582C6.45312 2.85605 6.69785 2.61133 7 2.61133C7.30215 2.61133 7.54688 2.85605 7.54688 3.1582V8.20312C7.54688 8.50527 7.30215 8.75 7 8.75C6.69785 8.75 6.45312 8.50527 6.45312 8.20312V3.1582ZM6.38477 10.2402C6.38477 10.5807 6.65957 10.8555 7 10.8555C7.34043 10.8555 7.61523 10.5793 7.61523 10.2402C7.61523 9.89981 7.34043 9.625 7 9.625C6.65957 9.625 6.38477 9.89981 6.38477 10.2402Z" fill="#FF832B" />
        </svg>

    );
};

export const PendingIcon = props => (
    <Icon component={PendingIconSvg} {...props} />
);
